import type { PasscodeChannel } from '../types/domain.types';

const PHONE_PREFIX = '+91';

export const sentTargetOf = (sentOn: PasscodeChannel, maskedTo: string): string =>
  sentOn === 'EMAIL' || maskedTo.startsWith('+') ? maskedTo : `${PHONE_PREFIX} ${maskedTo}`;
